import { HStack } from "@/components/Elements/Layouts/Stack";
import { Box } from "@mui/material";

export const Header: React.FC = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: 20,
        height: "60px",
        fontWeight: "bold",
        backgroundColor: "#313131",
      }}
      color="#ffffff"
    >
      <HStack alignItems="center" spacing={1}>
        LG Admin
      </HStack>
    </Box>
  );
};
